interface SummaryResultsParams {
    summary?: string;
    mdn?: string;
}

export const validateSummary = ({ summary, mdn }: SummaryResultsParams): { isError: boolean; response?: string } => {
    if (!mdn) {
        return {
            isError: true,
            response: "MDN is undefined",
        };
    }

    if (!summary) {
        return {
            isError: true,
            response: "Session summary is undefined",
        };
    }

    return {
        isError: false,
    };
};
